import { Theme } from 'styling/theme'
import { makeStyles } from '@material-ui/core'

export const useStyles = makeStyles((theme: Theme) => ({
    button: {
        border: 0,
        background: 'none',
        paddingLeft: 0,
    },
    icon: {
        marginRight: theme.spacing(1),
        fontSize: 14,
    },
    buttonText: {
        fontSize: 14,
        fontFamily: theme.typographyPresets.fonts.notoSans.regular,
    },
    divider: {
        marginTop: theme.spacing(1),
        marginBottom: theme.spacing(3),
    },
}))
